import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Calendar from 'react-calendar';
import { gettheUnboackedEmpActions, setEmpBlockpostistEmpEmpAction } from "../../../Redux/Slice"
import 'react-calendar/dist/Calendar.css';
import { useDispatch, useSelector } from 'react-redux';
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import upload from "../../../Assets/AppComponent/appraisal.svg"
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import ImageCropper from "../ReactcropOverall/Imagecrop";
import { store } from "../../../Redux/Store";
import axios from "axios";
import { PresentUrl } from "../../../text/apidata";

const BlockEmployeePopupEmp = (props) => {
    const { show, setShow, PageIndex } = props;
    const [search, setSearch] = useState("");
    const [EmpOtions, setEmpOtions] = useState([])
    const state = useSelector((state) => state)
    const dispatch = useDispatch()
    const [data, setData] = useState({
        status: "pending",
        reason: "",
        user_id: "",
        request_type: "request",
        blacklist: "",
    });
    const [reasonerr, setReasonErr] = useState("");
    const [emperr, setemperr] = useState("");
    const [profileFiles, setprofileIFile] = useState();
    const [PresentUrls, setPresentUrls] = useState([])
    const [PresentUrlsProfile, setpresenturlProfile] = useState({
        ProfileUrls: "",
    })

    const [CroppImageView, setCroppImageView] = useState(false);
    const [Url, setUrl] = useState("");
    const [blockedBool, setblockedBoll] = useState(false)

    useEffect(() => {
        const payload = {
            page_size: 10,
            page: 1,
            status: "",
            search: search,
            type: false,
            Popup: 1,
        };
        dispatch(gettheUnboackedEmpActions(payload));
    }, [search]);
    const handleInputChange = (se) => {
        setSearch(se);
    }

    useEffect(() => {
        if (state.UnbloadedEmployeeeDataEmp.UnbloackedEmpDatas != undefined) {
            let objectArray = [];
            state.UnbloadedEmployeeeDataEmp.UnbloackedEmpDatas.forEach((element) => {
                objectArray.push({
                    value: element.user_id.id,
                    label: element.user_id.first_name.toUpperCase(),
                });
            });
            setEmpOtions(objectArray);
        }
    }, [state.UnbloadedEmployeeeDataEmp.UnbloackedEmpDatas, search]);
    const handleChange = (val) => {
        setData({
            ...data,
            user_id: val.value
        });
        setemperr("");
    }

    const fileInputRef = useRef(null);

    const handleImageClick = () => {
        fileInputRef.current.click();
    };
    const getCroppedImg = (imageRef, crop, fileName) => {

        const canvas = document.createElement("canvas");
        const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
        const scaleY = imageRef.current.naturalHeight / imageRef.current.height;
        canvas.width = crop.width * scaleX;
        canvas.height = crop.height * scaleY;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            imageRef.current,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );



        return new Promise((resolve, reject) => {
            canvas.toBlob((blob) => {
                if (!blob) {
                    console.error("Canvas is empty");
                    return;
                }
                // const croppedFile = new File([blob], fileName, {
                //   type: "image/jpeg",
                // });
                const croppedFile = new File([blob], fileName, {
                    type: "image/jpeg",
                });
                var file = croppedFile;
                var reader = new FileReader();
                reader.onloadend = function () {
                    setUrl(reader.result);
                };
                reader.readAsDataURL(file);
                if (croppedFile) {
                    // setTimeout(() => {
                    setCroppImageView(false)

                    // }, 0);
                    const generateRandomNumber = () => {
                        return Math.floor(Math.random() * 100000);
                    };


                    const createPresentData = (croppedFile) => {
                        const randomNumber = generateRandomNumber();
                        const formattedFilename = `onboarding/blacklist/${"blacklist"}${randomNumber}.${croppedFile.type.split('/')[1]}`; // Use the file's extension
                        const Presentdata = {
                            multiple_files: [
                                {
                                    filename: formattedFilename,
                                    file_type: croppedFile.type,
                                },
                            ],
                        };

                        return Presentdata;
                    };



                    const Presentdata = createPresentData(croppedFile);
                    axios({
                        url: PresentUrl,
                        method: 'post',
                        data: Presentdata,
                        headers: {
                            Authorization:
                                "Bearer " +
                                store.getState().CustomUDSEMployeeLogin.CustomoginDATAs.session.token,
                        },
                    })
                        .then((response) => {
                            console.log('Files uploaded successfully:', response.data);
                            const uploadedFiles = response.data.data; // Adjust based on actual response structure
                            console.log(uploadedFiles, "uploadedFiles");

                            const newUrls = uploadedFiles.map(file => ({
                                url: file, // Adjust this based on the actual response
                                type: croppedFile.type,
                                putfiles: croppedFile
                            }));

                            setPresentUrls(newUrls);
                            setpresenturlProfile({
                                ProfileUrls: String(response.data.data).split("?")[0],
                            })

                        })
                        .catch((error) => {
                            console.error('Error uploading files:', error);
                        });
                }
                resolve(croppedFile);
            }, "image/jpeg");
        });
    }
    const handleInputChangeFile = (e) => {
        setblockedBoll(true)
        setprofileIFile(e);
        const file = e.target.files[0];
        const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"];
        const maxSize = 10 * 1024 * 1024; // 3MB in bytes
        const MIN_DIMENSION = 150;

        setCroppImageView(true);


        if (file && allowedTypes.includes(file.type)) {
            if (file.size > maxSize) {
                setCroppImageView(false);
                toast.error("File size exceeds 10MB. Please upload a smaller image.");
            } else {
                const reader = new FileReader();
                reader.addEventListener("load", () => {
                    const imageElement = new Image();
                    const imageUrl = reader.result?.toString() || "";
                    imageElement.src = imageUrl;

                    imageElement.addEventListener("load", (imgEvent) => {
                        const { naturalWidth, naturalHeight } = imgEvent.currentTarget;

                        if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                            toast.error("Image must be at least 150 x 150 pixels.");
                            setCroppImageView(false);
                            return;
                        }
                    });
                });
                reader.readAsDataURL(file);
            }
        } else {
            setCroppImageView(false);
            toast.error("Please upload an image file (jpg, jpeg, png, svg).");
        }
    };

    const updateAvatar = (imgSrc) => {
        fileInputRef.current.value = imgSrc;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        var a = 0



        const fetchUploadFiles = async () => {

            await Promise.all(PresentUrls.map(async (item) => {
                try {
                    if (item != undefined && item != null) {

                        const response = await fetch(item.url, {
                            method: 'PUT',
                            headers: {
                                'Content-Type': item.type,
                                "x-amz-acl": "public-read"
                            },
                            body: item.putfiles,
                        });

                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        setUrl(PresentUrlsProfile.ProfileUrls);
                        const payload = {
                            data: {
                                reason: data.reason,
                                request_type: "request",
                                blacklist: PresentUrlsProfile.ProfileUrls,
                                user_id: data.user_id,

                            }

                        }
                        dispatch(setEmpBlockpostistEmpEmpAction(payload))
                        setShow(false);
                    }


                } catch (error) {
                    console.error('Error uploading files:', error);
                }
            }));
        };
        if (data.user_id == "") {
            setemperr("Employee is requrid")
            a = 1
        }
        if (data.reason == "") {
            setReasonErr("Purpose is requried");
            a = 1;
        }
        if (a == 0 && blockedBool == true) {
            fetchUploadFiles();

        }
        if (blockedBool == false && a === 0) {
            const payload = {
                data: {
                    reason: data.reason,
                    request_type: "request",
                    blacklist: "",
                    user_id: data.user_id,

                }
            }
            dispatch(setEmpBlockpostistEmpEmpAction(payload));
             setShow(false)
        }
    }

    console.log(data, "CroppImageView");


    return (
        <>
            <div className="RoleCreatePopup">
                <div className="BeforePopUp">
                    <div className="RolePopups" style={{ width: "30%" }}>
                        <div className="asds">


                            <div class="ModalHeader">
                                <span>Block Request</span>
                                <div className="CloseIcon" onClick={(e) => setShow(false)}>
                                    <CloseOutlinedIcon />
                                </div>
                            </div>

                            <form className="row form-fields-wrapper FormBlocklist g-3" onSubmit={handleSubmit}>
                                <div className="row">
                                    <label
                                        className="col-12 p-0"
                                        htmlFor="to_date"
                                        style={{ marginLeft: '19px' }}
                                    >
                                        Employee
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <div className="col-12 LeaveApplyCalendar">
                                        <Select
                                            className="Selects"
                                            styles={{ position: "relative", top: "60px" }}
                                            options={EmpOtions}
                                            onChange={handleChange}
                                            onInputChange={handleInputChange}
                                            labelledBy="Select"
                                        />

                                    </div>
                                    <p className='Error' style={{marginLeft:"12px",marginTop:"5px"}}>{emperr}</p>
                                </div>

                                <div className="row mt-3">
                                    <label
                                        className="col-12 p-0"
                                        htmlFor="purpose"
                                        style={{ marginLeft: '19px' }}
                                    >
                                        Purpose
                                        <span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <div className="col-12">
                                        <input
                                            type="text"
                                            id="purpose"
                                            className="form-control"
                                            placeholder="Enter purpose"
                                            name="reason"
                                            onChange={(e) => {
                                                setData({
                                                    ...data,
                                                    reason: e.target.value
                                                });
                                                setReasonErr("")
                                            }}
                                        />
                                    </div>
                                    <p className='Error' style={{marginLeft:"12px",marginTop:"5px"}}>{reasonerr}</p>
                                </div>

                                <div className="row mt-3">
                                    <label
                                        className="col-12 p-0"
                                        htmlFor="purpose"
                                        style={{ marginLeft: '19px' }}
                                    >
                                        Support Document
                                    </label>
                                    <div className="col-12">
                                        <img
                                            src={Url == "" ? upload : Url}
                                            style={{
                                                width: "150px",
                                                height: "150px",
                                                border: "1px solid #000",
                                                borderRadius: "10px",
                                                cursor: 'pointer',
                                            }}
                                            onClick={handleImageClick}
                                        />
                                        <input
                                            type="file"
                                            hidden
                                            accept="image/png, image/jpeg"
                                            name="file"
                                            ref={fileInputRef}
                                            onChange={(event) => {
                                                handleInputChangeFile(event);
                                            }}
                                        />
                                    </div>
                                </div>




                            </form>
                            <div className='col-12 BlockcreateFooter'>

                                <button
                                    className=" btn CancelBtn"
                                    style={{ background: "#234492", color: "white" }}
                                    onClick={() => setShow(false)}
                                >
                                    Cancel
                                </button>

                                <button
                                    class="CancelBtn btn"
                                    type="submit"
                                    style={{ background: "#234492", color: "white" }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </button>
                                
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            {CroppImageView && (
                <ImageCropper
                    updateAvatar={updateAvatar}
                    selectedImage={profileFiles}
                    getCroppedImg={getCroppedImg}
                    closeModal={() => setCroppImageView(false)}
                />
            )}


        </>


    )
}

export default BlockEmployeePopupEmp